import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {EMAIL_MAKER_SHEET_MOBILE_WIDTH_THRESHOLD, type EmailMakerBottomSheetProps} from './email-maker-bottom-sheet.types';

/** Shared shell that fixes the invariant Modal props common to every email-maker mobile bottom sheet. */
export function EmailMakerBottomSheet({modalId, panelId, modalMaxHeight = '90vh', showDragHandle = true, children}: EmailMakerBottomSheetProps): ReactElement {
  return (
    <Modal
      modalId={modalId}
      panelId={panelId}
      showNonFunctionalDragHandle={showDragHandle}
      disableDragToClose={!showDragHandle}
      modalMaxHeight={modalMaxHeight}
      modalMaxWidth="100%"
      modalWidth="100%"
      stickToBottom
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      sizeToContent
      mobileModalWidthThreshold={EMAIL_MAKER_SHEET_MOBILE_WIDTH_THRESHOLD}
    >
      {children}
    </Modal>
  );
}
